module.exports = __webpack_public_path__ + "img/product-preview-78.d6e6d82.png";